import { render, staticRenderFns } from "./TreatmentQuantity.vue?vue&type=template&id=9dee0528&scoped=true&lang=pug&"
import script from "./TreatmentQuantity.vue?vue&type=script&lang=js&"
export * from "./TreatmentQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dee0528",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
